import React from "react";
import logo from "../../assets/Bramalea.png";
import sunrise_orange from "../../assets/sunrise_orange.png";
import sunset_orange from "../../assets/sunset_orange.png";

const SunInfo = ({ colorSettings = {}, prayerData }) => {
    const { 
        bodyTextColor = "#000", 
    } = colorSettings;

    const sunrise = prayerData?.startTimes?.timings?.sunrise || "--:--";
    const sunset = prayerData?.startTimes?.timings?.sunset || "--:--";

    const formatApiTime = (timeStr) => {
        if (!timeStr) return { time: "--:--", period: "" };

        const parts = timeStr.split(" "); 
        const timePart = parts[0] || "--:--"; 
        const [hour, minute] = timePart.split(":");

        const normalizedHour = parseInt(hour, 10);
        const formattedTime = `${normalizedHour}:${minute}`;

        return {
            time: formattedTime,
            period: parts[1] || ""
        };
    };

    const sunriseTime = formatApiTime(sunrise);
    const sunsetTime = formatApiTime(sunset);

    return (
        <div 
            className="flex justify-between items-center px-[4svh] w-full"
            style={{ color: bodyTextColor }}
        >
            {/* Sunrise (Fixed - Won't Shrink) */}
            <div className="flex flex-col items-center flex-shrink-0">
                <img
                    src={sunrise_orange}
                    alt="Sunrise"
                    className="w-[7svh]"
                />
                <p className="text-[2.5svh]">SUNRISE</p>
                <p className="flex items-baseline justify-center gap-0">
                    <span className="text-[4svh]">{sunriseTime.time}</span>
                    {sunriseTime.period && (
                        <span className="text-[2.8svh]">{sunriseTime.period}</span>
                    )}
                </p>
            </div>

            {/* Logo (Flexible - Will shrink if needed) */}
            {/* Changed from 'flex-shrink-0' to 'flex-1 min-w-0' */}
            <div className="flex-1 min-w-0 flex justify-center px-4">
                <img
                    src={logo}
                    alt="Logo"
                    // Added 'max-w-full' so it scales down if zoomed in
                    className="w-[30svh] max-w-full h-auto object-contain"
                />
            </div>

            {/* Sunset (Fixed - Won't Shrink) */}
            <div className="flex flex-col items-center flex-shrink-0">
                <img
                    src={sunset_orange}
                    alt="Sunset"
                    className="w-[7svh]"
                />
                <p className="text-[2.5svh]">SUNSET</p>
                <p className="flex items-baseline justify-center">
                    <span className="text-[4svh]">{sunsetTime.time}</span>
                    {sunsetTime.period && (
                        <span className="text-[2.8svh]">{sunsetTime.period}</span>
                    )}
                </p>
            </div>
        </div>
    );
};

export default SunInfo;